import React from 'react';
import * as styles from './SettingsSectionFooter.module.scss';

interface SettingsSectionFooterProps {
  children: React.ReactNode;
}

const SettingsSectionFooter = ({ children }: SettingsSectionFooterProps) => (
  <div className={styles.container}>{children}</div>
);

export default SettingsSectionFooter;
